import React from "react";
import DialogBox from "../DialogBox";
import { locale } from "../../utils/LocaleManager";
import { useContentStore } from "../../stores/contentStore";
import TreeView from "../TreeView";
import { Box, Card, CardContent, Container, Grid, Stack } from "@mui/material";
import { moveFolder } from "../../services/folderServices";
import { Bounce, toast } from "react-toastify";
import { useFolderStore } from "../../stores/folderStore";
import { moveFolderRequest } from "../../models/folder";
import FolderIcon from "@mui/icons-material/Folder";
import { handleError } from "../../utils/utilFunctions";

const MoveFolder = () => {
  const { setIsLoading } = useContentStore((state: any) => ({
    setIsLoading: state.setIsLoading,
  }));

  const {
    folderName,
    selectedFolderId,
    previousFolderName,
    setIsShowMoveFolder,
    folderId,
    setIsFolderMoveSuccess,
  } = useFolderStore((state: any) => ({
    selectedFolderId: state.selectedFolderId,
    folderName: state.folderName,
    previousFolderName: state.previousFolderName,
    setIsShowMoveFolder: state.setIsShowMoveFolder,
    folderId: state.folderId,
    setIsFolderMoveSuccess: state.setIsFolderMoveSuccess,
  }));

  const fetchMoveFolder = async (id: string, request: moveFolderRequest) => {
    try {
      setIsLoading(true);
      const moveAPI = await moveFolder(id, request);
      if (moveAPI?.status === 200) {
        setIsFolderMoveSuccess(true);
        setIsShowMoveFolder(false);
        toast.success(
          `"${previousFolderName}" folder has been moved to to "${folderName}"`,
          {
            position: "bottom-left",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            pauseOnFocusLoss: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
            onClose: async () => {
              setIsFolderMoveSuccess(false);
            },
          },
        );
      } else {
        handleError({
          status: moveAPI?.response?.status,
          toast,
          errorMessage: "",
          onClose: () => {},
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error moving videos:", error);
      handleError({
        status: 0,
        toast,
        errorMessage: `Error moving folder: ${error}`,
        onClose: () => {},
      });
    }
  };

  const submitMoveFolder = async () => {
    const id = folderId === 1 ? null : folderId;
    const request: moveFolderRequest = { parentFolderId: id };
    await fetchMoveFolder(selectedFolderId, request);
  };

  const renderMoveDialog = () => (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              width: "100%",
              height: "25rem",
              border: "0.06rem solid #8A8E94",
              borderRadius: "0.5rem",
              overflow: "auto",
            }}
          >
            <Stack>
              <Card variant="outlined" key={selectedFolderId}>
                <CardContent style={{ padding: "1.25rem" }}>
                  <Stack direction="row" gap="0.625rem">
                    <FolderIcon style={{ color: "#444746" }} />
                    {previousFolderName}
                  </Stack>
                </CardContent>
              </Card>
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              width: "100%",
              height: "25rem",
              border: "0.06rem solid #8A8E94",
              borderRadius: "0.5rem",
              overflow: "auto",
              padding: "0.5rem",
            }}
          >
            <TreeView />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );

  return (
    <DialogBox
      header={`Move "${previousFolderName}" folder to "${folderName}" folder`}
      body={<></>}
      subBody={renderMoveDialog()}
      onCancel={() => setIsShowMoveFolder(false)}
      onSubmit={submitMoveFolder}
      isDelete={false}
      disablePrimary={folderId === selectedFolderId}
      primaryButton={locale.control_move}
      secondaryButton={locale.cancel}
      width={"62.5rem"}
    />
  );
};

export default MoveFolder;
